import { DEFAULT_RETRY_POLICY } from "../../types/retry";

export function mergeRetryPolicy(overrides, base = DEFAULT_RETRY_POLICY) {
  const merged = {
    ...base,
    ...overrides,
  };

  return {
    ...merged,
    maxAttempts: Math.max(1, merged.maxAttempts ?? base.maxAttempts),
    initialDelayMs: Math.max(0, merged.initialDelayMs ?? base.initialDelayMs),
  };
}

export function calculateBackoffDelay(attempt, policy) {
  const maxDelay = policy.maxDelayMs ?? Number.POSITIVE_INFINITY;
  let delay;

  switch (policy.backoffStrategy) {
    case "fixed":
      delay = policy.initialDelayMs;
      break;
    case "linear":
      delay = policy.initialDelayMs * attempt;
      break;
    case "exponential":
    default:
      delay = policy.initialDelayMs * 2 ** (attempt - 1);
      break;
  }

  return Math.min(delay, maxDelay);
}
